import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DaLinkComponent } from './da-link.component';

@NgModule({
    declarations: [DaLinkComponent],
    imports: [CommonModule],
    exports: [DaLinkComponent]
})
export class DaLinkModule {}
